import TestimonialImg from "../../images/testimonials/testimonial-new.jpg";
import TestimonialBoxes from "./TestimonialBoxes";
import { FaWhatsapp, FaPhone } from "react-icons/fa6";

function Testimonials() {
  return (
    <>
      {/* testimonials div */}
      <section className="my-16 sm:my-24 mx-auto">
        <div className="container page-padding">
          {/* title */}
          <div className="text-center relative items-center w-full flex flex-col mb-12 sm:mb-16">
            <div className="relative inline-flex items-center justify-center gap-2 bg-[#ff0336] text-white text-[12px] sm:text-[13px] uppercase font-bold tracking-[3px] px-6 py-2 rounded-lg transform -skew-x-12 shadow-lg shadow-[#ff0336]/20">
              <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
              <span>Member Testimonials</span>
            </div>
            <h2 className="text-[26px] sm:text-[32px] md:text-[36px] font-bold mt-4 text-black">Real Stories, Real Results</h2>
          </div>

          {/* testimonials wrapper */}
          <div className="bg-black rounded-2xl border-4 sm:border-8 border-neutral-100 shadow-2xl p-6 sm:p-10 lg:p-12 relative overflow-hidden max-w-5xl mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 relative z-10">
              {/* img */}
              <div className="w-48 sm:w-60 lg:w-72 flex-shrink-0">
                <img
                  alt="fitness_member"
                  src={TestimonialImg}
                  className="w-full h-auto rounded-2xl object-cover shadow-lg border border-neutral-800"
                />
              </div>

              {/* all text-boxes */}
              <div className="flex-1 w-full">
                <TestimonialBoxes />
              </div>
            </div>
          </div>

          {/* CTA bar */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 justify-center items-center mt-12 sm:mt-16 border-b border-solid border-neutral-200 pb-12 sm:pb-16 max-w-4xl mx-auto">
            <a
              href={`https://wa.me/918637488702?text=Hi%2C%20I%20want%20to%20join%20FAT2FIT!`}
              target="_blank"
              rel="noreferrer"
              className="bg-[#25D366] text-white font-bold uppercase text-[13px] sm:text-[14px] py-3.5 px-6 sm:px-8 tracking-wider hover:opacity-90 transition-all duration-200 flex items-center justify-center gap-2 rounded-lg w-full sm:w-auto shadow-md"
            >
              <FaWhatsapp className="text-[18px]" /> WhatsApp Us
            </a>
            <a
              href="tel:8637488702"
              className="bg-[#FF0336] text-white font-bold uppercase text-[13px] sm:text-[14px] py-3.5 px-6 sm:px-8 tracking-wider hover:bg-[#cc0029] transition-all duration-200 flex items-center justify-center gap-2 rounded-lg w-full sm:w-auto shadow-md"
            >
              <FaPhone className="text-[16px]" /> Call: 86374 88702
            </a>
            <a
              href="tel:9597557006"
              className="border-2 border-[#FF0336] text-[#FF0336] font-bold uppercase text-[13px] sm:text-[14px] py-3.5 px-6 sm:px-8 tracking-wider hover:bg-[#FF0336] hover:text-white transition-all duration-200 flex items-center justify-center gap-2 rounded-lg w-full sm:w-auto"
            >
              <FaPhone className="text-[16px]" /> Alt: 95975 57006
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
